<ng-container>
    <div class="w-full flex justify-center mt-3">
        <div class="edit-customer-dialog-container flex flex-col px-6 py-1.5 w-full max-w-3xl">
            <span class="text-base font-semibold pb-9" style="font-family: 'Open Sans';">
                Contact Preference (this repair order)
            </span>
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                Override customer's message preference</span>
            <form id="overrideForm" class="flex flex-col w-auto pb-9 space-y-3" [formGroup]="overrideOptionsForm">
                <div class="flex flex-row pr-12 space-x-6">
                    <div class="flex flex-col w-1/3">
                        <mat-form-field appearance="outline" class="text-sm">
                            <mat-select formControlName="messagePreference" placeholder="Message Preference"
                                (selectionChange)="changeContactInfoPlaceholder($event.value, dialogData.appointmentDropdowns.messageTypes)">
                                <mat-option
                                    *ngFor="let messageType of dialogData.appointmentDropdowns.messageTypes | filterBy: ['id']: [1,2]"
                                    [value]="messageType.id">
                                    {{messageType.description}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formSubmitted && overrideOptionsForm.get('messagePreference').errors">
                                A message preference is required to override
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <ng-container [ngSwitch]="overrideOptionsForm.get('messagePreference').value">
                        <div class="flex flex-col w-1/3" *ngSwitchCase="1">
                            <mat-form-field appearance="outline" class="text-sm">
                                <input id="messagePreferenceContactInfo" matInput
                                    formControlName="messagePreferenceContactInfo" class="font-normal"
                                    style="font-family: 'Open Sans'; color: #444"
                                    placeholder="{{contactInfoPlaceholderText}}" autocomplete="one-time-code">
                                <mat-error
                                    *ngIf="formSubmitted && overrideOptionsForm.get('messagePreferenceContactInfo').errors">
                                    {{overrideOptionsForm.get('messagePreferenceContactInfo').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex flex-col w-1/3" *ngSwitchCase="2">
                            <mat-form-field appearance="outline" class="text-sm">
                                <input id="messagePreferenceContactInfo" matInput
                                    formControlName="messagePreferenceContactInfo"
                                    [textMask]="{mask: phoneNumberMask, guide: false}" class="font-normal"
                                    style="font-family: 'Open Sans'; color: #444"
                                    placeholder="{{contactInfoPlaceholderText}}" autocomplete="one-time-code"
                                    type="text" inputmode="numeric">
                                <mat-error
                                    *ngIf="formSubmitted && overrideOptionsForm.get('messagePreferenceContactInfo').errors">
                                    {{overrideOptionsForm.get('messagePreferenceContactInfo').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex flex-col w-1/3" *ngSwitchDefault>
                            <mat-form-field appearance="outline" class="text-sm">
                                <input id="messagePreferenceContactInfo" matInput
                                    formControlName="messagePreferenceContactInfo" class="font-normal"
                                    style="font-family: 'Open Sans'; color: #444"
                                    placeholder="{{contactInfoPlaceholderText}}" autocomplete="one-time-code">
                                <mat-error
                                    *ngIf="formSubmitted && overrideOptionsForm.get('messagePreferenceContactInfo').errors">
                                    {{overrideOptionsForm.get('messagePreferenceContactInfo').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </ng-container>
                </div>
                <div class="flex flex-row">
                    <span class="font-semibold text-sm mb-3 mr-14" style="font-family: 'Open Sans'; color: #282828">
                        Exclude Communicator Messaging</span>
                    <mat-slide-toggle matInput labelPosition="before"
                        formControlName="excludeCommunicator"></mat-slide-toggle>
                </div>
            </form>

            <span class="text-base font-semibold pb-9" style="font-family: 'Open Sans';">
                Customer Information
            </span>
            <div class="flex flex-col w-full">
                <div class="flex flex-row mb-3 w-full space-x-6">
                    <form id="messagePreferenceInput" class="w-1/3" [formGroup]=dialogData.associateForm>
                        <div class="flex flex-col">
                            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                                Message Preference<sup>*</sup></span>
                            <mat-form-field appearance="outline" class="text-sm">
                                <mat-select formControlName="messagePreferenceId" required>
                                    <mat-option
                                        *ngFor="let messageType of dialogData.appointmentDropdowns.messageTypes | filterBy: ['id']: [1,2,4]"
                                        [value]="messageType.id">
                                        {{messageType.description}}</mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formSubmitted && dialogData.associateForm.get('messagePreferenceId').errors">
                                    {{dialogData.associateForm.get('messagePreferenceId').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </form>
                    <form id="emailAddressInput" class="w-1/3" [formGroup]=dialogData.associateForm>
                        <div class="flex flex-col">
                            <span class="font-semibold text-sm mb-3"
                                style="font-family: 'Open Sans'; color: #282828">Email Address<span
                                    *ngIf="dialogData.associateForm.get('messagePreferenceId').value === 1"><sup>*</sup></span></span>
                            <mat-form-field appearance="outline" class="text-sm">
                                <input id="emailAddress" matInput formControlName="emailAddress" autocomplete="off">
                                <mat-error *ngIf="formSubmitted && dialogData.associateForm.get('emailAddress').errors">
                                    {{dialogData.associateForm.get('emailAddress').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </form>
                    <form id="cellPhoneNumberInput" class="w-1/3" [formGroup]=dialogData.addressForm>
                        <div class="flex flex-col">
                            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                                Cell Phone<span
                                    *ngIf="dialogData.associateForm.get('messagePreferenceId').value === 2"><sup>*</sup></span></span>
                            <mat-form-field appearance="outline" class="text-sm">
                                <input id="cellPhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
                                    formControlName="cellPhoneNumber" type="text" inputmode="numeric" autocomplete="off">
                                <mat-error
                                    *ngIf="formSubmitted && dialogData.addressForm.get('cellPhoneNumber').errors">
                                    {{dialogData.addressForm.get('cellPhoneNumber').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </form>
                </div>
                <form id="addressForm" class="flex flex-col w-full space-y-3" [formGroup]=dialogData.addressForm>
                    <div class="flex flex-row space-x-6">
                        <div class="flex flex-col w-1/3">
                            <span class="font-semibold text-sm mb-3"
                                style="font-family: 'Open Sans'; color: #282828">Address<sup>*</sup></span>
                            <mat-form-field appearance="outline" class="text-sm">
                                <input id="addressLine1" matInput formControlName="addressLine1" required autocomplete="off">
                                <mat-error *ngIf="formSubmitted && dialogData.addressForm.get('addressLine1').errors">
                                    {{dialogData.addressForm.get('addressLine1').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex flex-col w-1/3">
                            <span class="font-semibold text-sm mb-3"
                                style="font-family: 'Open Sans'; color: #282828">Province/State<sup>*</sup></span>
                            <mat-form-field appearance="outline" class="text-sm">
                                <mat-select required formControlName="provStateId">
                                    <mat-option
                                        *ngFor="let provinceState of dialogData.appointmentDropdowns.provinceStates"
                                        [value]="provinceState.id">
                                        {{ provinceState.name }}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="formSubmitted && dialogData.addressForm.get('provStateId').errors">
                                    {{dialogData.addressForm.get('provStateId').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="flex flex-col w-1/3">
                            <span class="font-semibold text-sm mb-3"
                                style="font-family: 'Open Sans'; color: #282828">Location<sup>*</sup></span>
                            <mat-form-field appearance="outline" class="text-sm">
                                <mat-select #location required formControlName="locationId">
                                    <mat-option *ngFor="let location of dialogData.locations$ | async"
                                        [value]="location.id">
                                        {{location.description}} {{location.provStateId}},
                                        {{location.countryId}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="formSubmitted && dialogData.addressForm.get('locationId').errors">
                                    {{dialogData.addressForm.get('locationId').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="flex flex-row pr-12 space-x-6">
                        <div class="flex flex-col w-1/3">
                            <span class="font-semibold text-sm mb-3"
                                style="font-family: 'Open Sans'; color: #282828">Postal/Zip Code</span>
                            <mat-form-field appearance="outline" class="text-sm">
                                <input id="postalZipCode" matInput formControlName="postalZipCode" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="flex flex-col w-1/3">
                            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
                                Home Phone</span>
                            <mat-form-field appearance="outline" class="text-sm">
                                <input id="homePhoneNumber" matInput [textMask]="{mask: phoneNumberMask, guide: true}"
                                    formControlName="homePhoneNumber" type="text" inputmode="numeric" autocomplete="off">
                                <mat-error
                                    *ngIf="formSubmitted && dialogData.addressForm.get('homePhoneNumber').errors">
                                    {{dialogData.addressForm.get('homePhoneNumber').errors | inputError}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </form>
            </div>
            <div class="w-full h-full bg-white mt-10">
                <div class="flex flex-row place-content-end items-center">
                    <span (click)="cancel()" class="flex place-items-center place-content-center py-2.5 px-5 rounded-md"
                        [ngStyle]="{ border: '1px solid #515251', cursor: 'pointer'}"
                        style="font-family: 'Open Sans'; height: 34px">Cancel</span>
                    <button (click)="save(dialogData.associateForm, dialogData.addressForm, overrideOptionsForm)"
                        id="saveButton" class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3"
                        [ngStyle]="{ background: 'rgba(0, 84, 166, 1)', cursor: 'pointer'}"
                        style="font-family: 'Open Sans'; height: 34px" type="submit">
                        <span class="text-white font-medium text-sm">Save</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-container>